import "../../../components/cps-input-with-units";
import "./walk-in-panel";
import WalkInPanel from "./walk-in-panel";
import elt from "../../../html/elt";
import injectCSS from "../../../html/inject-css";
import { CpsInputWithUnits } from "../../../components/cps-input-with-units";
import { getSavedMode, NavigationMode } from "../walk-in-camera-manager";
import { registerListener } from "../../../html/register-listener";
import { uuid4 } from "../../../utils";

export class WalkInCameraPanel extends WalkInPanel {

    fp: HTMLInputElement;
    orbit: HTMLInputElement;
    overhead: HTMLInputElement;
    showRenderFrame: HTMLInputElement;
    focalLengthRange: HTMLInputElement;
    focalLengthInput: CpsInputWithUnits;
    grid: HTMLElement;

    constructor() {
        super();
        injectCSS(STYLESHEET);

        const mode = getSavedMode();

        const
            fpId = uuid4(),
            checked = { checked: 'true' },
            fp = this.fp =
                elt('input',
                    {
                        type: 'radio',
                        class: 'form-check-input',
                        name: 'walk-in-camera-nav-mode',
                        id: fpId,
                        ...(mode == 'fp' ? checked : {}),
                    }),
            orbitId = uuid4(),
            orbit = this.orbit =
                elt('input',
                    {
                        type: 'radio',
                        class: 'form-check-input',
                        name: 'walk-in-camera-nav-mode',
                        id: orbitId,
                        ...(mode == 'orbit' ? checked : {}),
                    }),
            overheadId = uuid4(),
            overhead = this.overhead =
                elt('input',
                    {
                        type: 'checkbox',
                        class: 'form-check-input',
                        id: overheadId,
                        ...(mode == 'overhead' ? checked : {}),
                    }),
            showRenderFrameId = uuid4(),
            showRenderFrame = this.showRenderFrame =
                elt('input',
                    {
                        type: 'checkbox',
                        class: 'form-check-input',
                        id: showRenderFrameId,
                    }),
            focalLengthRange = this.focalLengthRange =
                elt('input',
                    {
                        type: 'range',
                        class: 'form-range',
                        min: '10',
                        max: '120',
                        value: '22',
                    }),
            focalLengthInput = this.focalLengthInput =
                elt('cps-input-with-units',
                    {
                        units: 'mm',
                        value: '22',
                    }),
            focalLengthReset = elt(
                'i',
                {
                    class: 'fs-3 bi-arrow-counterclockwise',
                    title: 'Reset',
                });


        this.grid = elt(
            'div', { class: 'camera-panel-layout' },
            fp,
            elt('label', { for : fpId, class: 'form-check-label' }, 'Keyboard'),
            orbit,
            elt('label', { for : orbitId, class: 'form-check-label' }, 'Orbit'),
            overhead,
            elt('label', { for : overheadId, class: 'form-check-label' }, 'Overhead (o)'),
            showRenderFrame,
            elt('label', { for : showRenderFrameId, class: 'form-check-label' }, '16:9 Frame (f)'),
            elt('div', { class: 'camera-panel-zoom-layout' },
                focalLengthRange,
                elt('label', {class: 'form-label'}, 'Zoom'),
                focalLengthInput,
                focalLengthReset,
            ));


        registerListener(fp, 'change', this.handleModeChange);
        registerListener(orbit, 'change', this.handleModeChange);
        registerListener(overhead, 'change', this.handleModeChange);
        registerListener(showRenderFrame, 'change', this.updateRenderFrame);

        registerListener(focalLengthRange, 'input', () => {
            if(focalLengthInput.value != focalLengthRange.value) {
                focalLengthInput.value = focalLengthRange.value;
            }
            this.dispatchEvent(
                new CustomEvent('camera-focal-length-input', {bubbles: true}));
        });
        registerListener(focalLengthInput, 'change', () => {
            if(focalLengthRange.value != focalLengthInput.value) {
                focalLengthRange.value = focalLengthInput.value;
            }
            this.dispatchEvent(
                new CustomEvent('camera-focal-length-change', {bubbles: true}));
        });
        registerListener(focalLengthReset, 'click', () => {
            this.focalLengthRange.value = this.focalLengthInput.value = '22';
            this.dispatchEvent(
                new CustomEvent('camera-focal-length-change', {bubbles: true}));
        });
    }

    connectedCallback() {
        this.append(this.grid);
    }

    handleModeChange = () => {
        const disabled = this.getMode() == "overhead";
        this.fp.disabled = disabled;
        this.orbit.disabled = disabled;

        this.dispatchEvent(new CustomEvent('nav-mode-change', {bubbles: true}));
    }

    updateRenderFrame = () => {
        this.dispatchEvent(
            new CustomEvent('render-frame-visibility-change', {bubbles: true}));
    }

    getMode(): NavigationMode {
        switch(true) {
            // Overhead must come first b/c it overrides the others
            case this.overhead.checked:
                return "overhead";
            case this.fp.checked:
                return "fp";
            case this.orbit.checked:
                return "orbit";
        }
    }

    setMode(mode: NavigationMode) {
        switch(mode) {
            case "fp":
                this.fp.checked = true;
                this.fp.disabled = false;
                this.orbit.checked = false;
                this.orbit.disabled = false;
                this.overhead.checked = false;
                break;
            case "orbit":
                this.fp.checked = false;
                this.fp.disabled = false;
                this.orbit.checked = true;
                this.orbit.disabled = false;
                this.overhead.checked = false;
                break;
            case "overhead":
                this.fp.disabled = true;
                this.orbit.disabled = true;
                this.overhead.checked = true;
        }
    }

}
export default WalkInCameraPanel;
window.customElements.define('walk-in-camera-panel', WalkInCameraPanel);

const STYLESHEET = `
walk-in-camera-panel {

    & .camera-panel-layout {
        display: grid;
        grid-template-columns: auto 1fr;
        grid-gap: 1rem;
    }

    & .camera-panel-zoom-layout {
        grid-column: 1 / span 2;

        display: grid;
        align-items: center;
        grid-template-columns: 1fr auto auto;
        grid-gap: 0.5rem;

        & input[type=range] {
            grid-column: 1 / span 3;
        }

        & cps-input-with-units {
            width: 12ch;
        }
    }
}
`;
